type Processor<T> = (item: T) => void;

/**
 * If the analytics script isn't ready, then this class can be used to create and manage an analytics queue.
 */
export default class <T>{
    private key = '';
    private hasQueueBeenProcessed = false;
    private processItem: Processor<T> = () => {};

    constructor(key: string, processor: Processor<T>) {
        this.processItem = processor;
        this.key = `${key}Queue`;

        if (typeof window !== 'undefined' && !window[this.key]) {
            window[this.key] = [];
        }
    }

    process = () => {
        if (this.hasQueueBeenProcessed) {
            return;
        }

        while (window[this.key].length) {
            const item = window[this.key].shift();
            this.processItem(item);
        }

        window[this.key] = undefined;
        this.hasQueueBeenProcessed = true;
    }

    add = (item: T) => {
        window[this.key].push(item);
    }
}
